export default __webpack_public_path__ + "static/media/play_banner.a467aef3.png";